import { Component, Host, Prop, h } from '@stencil/core';

@Component({
  tag: 's-icon',
  shadow: false,
})
export class SIcon {
  @Prop({ reflect: true }) name: string;

  render() {
    return <Host role="img"></Host>;
  }
}
